let replicateOptions = false;

export function activateReplicateOptions() {
    replicateOptions = true;
}

export function isReplicateOptions() {
    return replicateOptions;
}